import { useCallback, useEffect, useState } from 'react';
import { useEvent } from '../pages/events/event/EventProvider';
import { useGlobalState } from '../state/GlobalStateProvider';
import { useBackendApi } from './backendHelper';

const useCoinshiftHelper = () => {
  const [{ user }] = useGlobalState();
  const [userStats, setUserStats] = useState();
  const [userLoading, setUserLoading] = useState(false);
  const backendHelper = useBackendApi();
  const [{ nftProfie }] = useEvent();

  const getUserDetails = useCallback(async () => {
    // if (!nftProfie) return;
    setUserLoading(true);
    if (user?.coinshiftEmail) {
      try {
        const userData = await backendHelper.user.getCoinshiftUserDetails();
        if (userData) {
          setUserStats(userData);
        }
      } catch (error) {
      } finally {
        setUserLoading(false);
      }
    }
  }, [backendHelper, user]);

  useEffect(() => {
    getUserDetails();
  }, [user]);

  return [userStats];
};

export default useCoinshiftHelper;
